import React from 'react';
import GetExecutionData from 'src/dto/response/getExecution';
import Container from './tracking.container';

type IProps = {
  selectedShipment: GetExecutionData;
}

const AirCargo: React.FC<IProps> = (props) => {
  const { selectedShipment } = props;
  return (
    <Container
      selectedShipment={selectedShipment}
      isAwb={true}
    />
  );
}

export default AirCargo;
